import * as z from 'zod';

export const QUESTION_ORDER_TYPE_ANSWERED_AT = 'AnsweredAt';
export const QUESTION_ORDER_TYPE_RECOMMEND = 'recommend';
export const questionOrderType = {
  answeredAt: QUESTION_ORDER_TYPE_ANSWERED_AT,
  recommend: QUESTION_ORDER_TYPE_RECOMMEND,
} as const;
export type QuestionOrderType =
  (typeof questionOrderType)[keyof typeof questionOrderType];

export const ANSWER_ORDER_TYPE_LIKED_COUNT = 'LikeCount';
export const ANSWER_ORDER_TYPE_ANSWERED_AT = 'AnsweredAt';
export const answerOrderType = {
  likeCount: ANSWER_ORDER_TYPE_LIKED_COUNT,
  answeredAt: ANSWER_ORDER_TYPE_ANSWERED_AT,
};

export type AnswerOrderType =
  (typeof answerOrderType)[keyof typeof answerOrderType];

export const BOX_PAGE_FEED = '/box/answers';
export const BOX_PAGE_QUESTIONS = '/box/questions';
export const BOX_PAGE_QUESTION_ADD = '/box/questions/add';
export const BOX_PAGE_QUESTION_DETAIL = '/box/questions/:questionId';
export const BOX_PAGE_QUESTION_ANSWER = '/box/questions/:questionId/answer';
export const BOX_PAGE_ADVISER_DETAIL = '/box/users/:adviserName';
export const BOX_PAGE_PROFILE_EDIT = '/box/users/me/edit';

export const BOX_PATH_FEED = '/box/answers';
export const BOX_PATH_TOP_QUESTIONS = '/box/questions';
export const BOX_PATH_QUESTIONS_ADD = `${BOX_PATH_TOP_QUESTIONS}/add`;
export const BOX_PATH_TOP_ADVISERS = '/box/users';
export const BOX_PATH_ADVISERS_ME_EDIT = `${BOX_PATH_TOP_ADVISERS}/me/edit`;

export const BOX_PAGE_AUTH = '/box/auth';

export const ADVISER_CATEGORIES = [
  {name: 'すべての業界', hashtagIds: []},
  {name: '人生相談', hashtagIds: [3490]},
  {name: 'Tech', hashtagIds: [3491]},
  {name: 'GAFAM', hashtagIds: [3492]},
  {name: 'ベンチャー', hashtagIds: [1580]},
  {name: 'コンサル', hashtagIds: [1545]},
  {name: 'IB・金融', hashtagIds: [3497, 1501]},
  {name: '外資メーカー', hashtagIds: [941]},
  {name: 'ファンド', hashtagIds: [1645]},
  {name: '商社・広告', hashtagIds: [1526, 1724]},
  {name: '日系大手', hashtagIds: [3493]},
  {name: 'その他', hashtagIds: [3495, 3496, 1011]},
];

const AdviserCategory = z.object({
  name: z.string(),
  hashtagIds: z.array(z.number()),
});
export type AdviserCategory = z.infer<typeof AdviserCategory>;

export const TAB_ADVISER_QUESTIONS = 'adviserQuestions';
export const TAB_OPEN_QUESTIONS = 'openQuestions';

export const TWITTER_DOMAIN = 'https://twitter.com';

export const OGP_IMAGE_PATH_BOX = '/next-image/box/ogp.jpg';

export const FORM_STATUS_ADD = 'add';
export const FORM_STATUS_CONFIRM = 'confirm';
export const FORM_STATUS_DONE = 'done';

export const answerFormStatus = {
  add: FORM_STATUS_ADD,
  confirm: FORM_STATUS_CONFIRM,
  done: FORM_STATUS_DONE,
} as const;
export type AnswerFormStatus =
  (typeof answerFormStatus)[keyof typeof answerFormStatus];

export const questionFormStatus = {
  add: FORM_STATUS_ADD,
  confirm: FORM_STATUS_CONFIRM,
  done: FORM_STATUS_DONE,
} as const;
export type QuestionFormStatus =
  (typeof questionFormStatus)[keyof typeof questionFormStatus];
